import { useMemo } from "react";
import { useItems, Item, ItemsFilters, PaginatedItems } from "@/hooks/useItems";
import { useProductStock } from "@/hooks/useProductStock";

export interface CatalogStockItem extends Item {
  stock_quantity: number;
  has_stock_entry: boolean;
}

export function useCatalogStock(filters?: ItemsFilters) {
  const { data: itemsData, isLoading: itemsLoading } = useItems(filters);
  const { data: stockData, isLoading: stockLoading } = useProductStock();

  const stockByItemId = useMemo(() => {
    const map = new Map<string, number>();
    (stockData ?? []).forEach((s) => {
      map.set(s.item_id, s.quantity);
    });
    return map;
  }, [stockData]);

  const items: CatalogStockItem[] = useMemo(() => {
    const raw: Item[] = Array.isArray(itemsData)
      ? itemsData
      : (itemsData as PaginatedItems | undefined)?.data ?? [];
    return raw.map((item) => {
      const qty = stockByItemId.get(item.id);
      return {
        ...item,
        stock_quantity: qty ?? 0,
        has_stock_entry: qty !== undefined,
      };
    });
  }, [itemsData, stockByItemId]);

  const pagination = useMemo(() => {
    if (!itemsData || Array.isArray(itemsData)) return null;
    return itemsData as PaginatedItems;
  }, [itemsData]);

  return {
    items,
    pagination,
    isLoading: itemsLoading || stockLoading,
  };
}
